import ReactPlayer from "react-player/youtube";
import useConfig from "../../hooks/config/useConfig";

const videoUrlByCountry: { [key: string]: string } = {
  UY: "https://youtu.be/acnOdevwUtQ",
  CO: "https://www.youtube.com/watch?v=ePNTIGWzsBU",
  CL: "https://www.youtube.com/watch?v=69wc2r0AN9I",
};

export const LoginVideo = () => {
  const { country } = useConfig();

  const videoUrl = videoUrlByCountry[country] || videoUrlByCountry.UY;

  return (
    <div className="login-video h-100 w-100 d-flex align-items-center justify-content-center">
      <div className="login-video-wrapper">
        <ReactPlayer
          className="login-video-player"
          url={videoUrl}
          width="100%"
          height="100%"
          controls
        />
      </div>
    </div>
  );
};
